import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class S3UploadService {
    constructor(@Inject('BASE_API_URL') private baseUrl: string, private http: HttpClient) {
  }


  uploadFile(file: File, preSignedUrl: string): Observable<HttpEvent<any>> {
    return this.http.put<void>(preSignedUrl, file, {
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      reportProgress: true,
      observe: 'events'
    });
  }

  getPresignedUrl(key: string): Observable<{key: string, url: string }> {
    return this.http.get<{ key: string, url: string }>(`${this.baseUrl}/v1/s3/presigned-url?key=${encodeURIComponent(key)}`);
  }
}
